import * as React from 'react';
import { ICommand, ICommandStateProps } from '../../../models/commands/ICommand';
import { Facet } from '../../../models/Facet';
import { FollowAction } from '../../actions/follow/FollowAction';
import CommandStrings from '../Commands.resx';
import { ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

const commandName = (isToggled: boolean): string => {
  return isToggled ? CommandStrings.RemoveFromSaved : CommandStrings.SaveForLater;
};

export const followCommand: ICommand = {
  key: new Facet('follow').id,
  automationId: 'followCommand',
  action: <FollowAction />,
  name: CommandStrings.SaveForLater,
  postProcess: (item: ICommandBarItemProps): ICommandBarItemProps => {
    return {
      ...item,
      name: commandName(item.actionState.isToggled)
    };
  },
  commandBarButtonAs: (props: IComponentAsProps<ICommandBarItemProps> & ICommandStateProps) => {
    const DefaultRender = props.defaultRender;
    const isToggled = props.actionState && props.actionState.isToggled;
    const name = typeof (isToggled) === 'boolean' && commandName(isToggled) || undefined;
    return (
      DefaultRender ?
        (
          <DefaultRender
            { ...props }
            iconProps={
              { iconName: isToggled ? 'SingleBookmarkSolid' : 'SingleBookmark' }
            }
            name={ props.iconOnly ? undefined : name }
            text={ props.iconOnly ? undefined : name }
          />
        ) : null
    );
  }
};